export default __webpack_public_path__ + "static/media/decorationMain_desktop.486d4b6a.svg";